import React from "react";
import { ref as storageRef } from "firebase/storage";
import { useFirebase } from "contexts/Firebase";
import moment from "moment";
import Webcam from "react-webcam";
import { useUploadFile } from "react-firebase-hooks/storage";
import { deleteObject, ref } from "firebase/storage";
import { useAuth } from "contexts/User";

export function useFileHandling() {
  const { storage } = useFirebase();
  const { user } = useAuth();
  const [uploadFile, uploading] = useUploadFile();
  const [files, setFiles] = React.useState<Array<{ name: string; path: string; type: string }>>([]);
  const [fileError, setFileError] = React.useState<string | null>(null);
  const webcamRef = React.useRef<Webcam>(null);
  const [photo, setPhoto] = React.useState(false);
  const [facingMode, setFacingMode] = React.useState(true);

  const takePhoto = async () => {
    webcamRef.current?.getCanvas()?.toBlob(
      async (blob) => {
        if (!blob) return;
        const fileName = `photo-${moment().unix()}.png`;
        const path = `users/${user?.uid}/reimbursementRequests/${fileName}`;
        await uploadFile(storageRef(storage, path), blob, {
          contentType: "image/png",
        });
        setFiles([...files, { name: fileName, path, type: "image/png" }]);
        setPhoto(false);
      },
      "image/png",
      1
    );
  };

  const uploadFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = e.target.files;
    if (!uploadedFiles) return;

    for (let i = 0; i < uploadedFiles.length; i++) {
      const file = uploadedFiles[i];
      const fileName = `${file.name}`;
      const path = `/users/${user?.uid}/reimbursementRequests/${fileName}`;
      await uploadFile(storageRef(storage, path), file, {
        contentType: file.type,
      });
      setFiles([...files, { name: fileName, path, type: file.type }]);
    }
  };

  const deleteFile = async (fileName: string) => {
    const fileRef = ref(storage, `users/${user?.uid}/reimbursementRequests/${fileName}`);
    try {
      await deleteObject(fileRef);
      setFiles(files.filter((file) => file.name !== fileName));
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  return {
    files,
    setFiles,
    fileError,
    setFileError,
    uploading,
    uploadFile,
    photo,
    setPhoto,
    facingMode,
    setFacingMode,
    webcamRef,
    takePhoto,
    uploadFiles,
    deleteFile,
  };
}
